import React from 'react'
import Loader from 'react-loader-spinner'
import styled from 'styled-components'
import PropTypes from 'prop-types'
const Loading = styled(Loader)`
  margin-top: ${props => props.top};
  margin-bottom: ${props => props.bottom};
  position: ${props => (props.isAbsolute ? 'absolute' : 'relative')};
`
export default function LoaderComponent(props) {
  const { visible, height, width, type, color, top, bottom, isAbsolute } = props
  return (
    <Loading
      top={top}
      bottom={bottom}
      type={type}
      color={color}
      height={height}
      width={width}
      timeout={0}
      visible={visible}
      isAbsolute={isAbsolute}
      className="text-center"
    />
  )
}
LoaderComponent.propTypes = {
  visible: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
  type: PropTypes.string,
  color: PropTypes.string,
  top: PropTypes.string,
  bottom: PropTypes.string,
  isAbsolute: PropTypes.bool,
}
LoaderComponent.defaultProps = {
  width: 80,
  height: 80,
  type: 'TailSpin',
  color: '#5ccc9c',
  top: '20vh',
  bottom: '30vh',
  isAbsolute: false,
}
